// extracted by mini-css-extract-plugin
export default {"button":"ConceptFixedButton_button__10rnf"};